export { default as Analytics } from "./AnalyticsDashboard";
import { ResourceOptions } from 'react-admin';
import { Resources } from '../resource';
import Views from './AnalyticsDashboard';


export const list = Views;

export const name = Resources.analytics
export const options: ResourceOptions = {
  label: 'resource.analytics',
};